// extracted by mini-css-extract-plugin
export default {"grid":"StreamDetail_grid__4Z003"};